import React from 'react';
import TemplatePanel from './TemplatePanel';
import ElementsPanel from './ElementsPanel';
import TextPanel from './TextPanel';
import MediaPanel from './MediaPanel';
import QRCodePanel from './QRCodePanel';
import ChartPanel from './ChartPanel';
import UploadPanel from './UploadPanel';
import ColorPanel from './ColorPanel';

import BrandKitPanel from './BrandKitPanel';

const ContentPanel = ({
  activePanel,
  onClose,
  onAddElement,
  onSetBackground,
  backgroundConfig,
  onSelectTemplate,
  categoryFromHome,
  templateTypeId,
  brandKit,
  onBrandKitChange,
  onApplyBrand,
  selectedElement,
  onEnterTextEdit,
  onUploadStart,
  onUploadEnd,
  onPickImage,
}) => {
  if (!activePanel) return null;

  const renderPanel = () => {
    switch (activePanel) {
      case 'templates':
        return (
          <TemplatePanel
            categoryFromHome={categoryFromHome}
            templateTypeId={templateTypeId}
            onSelectTemplate={onSelectTemplate}
            onClose={onClose}
          />
        );
      case 'elements':
        return <ElementsPanel onAddElement={onAddElement} onClose={onClose} />;
      case 'text':
        return <TextPanel onAddElement={onAddElement} onClose={onClose} selectedElement={selectedElement} onEnterTextEdit={onEnterTextEdit} />;
      case 'media':
        return <MediaPanel onAddElement={onAddElement} onClose={onClose} onUploadStart={onUploadStart} onUploadEnd={onUploadEnd} onPickImage={onPickImage} />;
      case 'qrcode':
        return <QRCodePanel onAddElement={onAddElement} onClose={onClose} />;
      case 'charts':
        return <ChartPanel onAddElement={onAddElement} onClose={onClose} />;
      case 'upload':
        return <UploadPanel onAddElement={onAddElement} onClose={onClose} onPickImage={onPickImage} />;
      case 'brand':
        return (
          <BrandKitPanel
            brandKit={brandKit}
            onBrandKitChange={onBrandKitChange}
            onAddElement={onAddElement}
            onClose={onClose}
            onApplyBrand={onApplyBrand}
          />
        );
      case 'color':
        return <ColorPanel onSetBackground={onSetBackground} backgroundConfig={backgroundConfig} onClose={onClose} onUploadStart={onUploadStart} onUploadEnd={onUploadEnd} />;

      default:
        return null;
    }
  };

  return (
    <div className="w-72 bg-white border-r flex flex-col h-full" data-testid="content-panel">
      {renderPanel()}
    </div>
  );
};

export default ContentPanel;
